import { render } from "./WrapPage.vue?vue&type=template&id=090d8fb0&scoped=true&ts=true"
import script from "./WrapPage.vue?vue&type=script&lang=ts"
export * from "./WrapPage.vue?vue&type=script&lang=ts"

import "./WrapPage.vue?vue&type=style&index=0&id=090d8fb0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Lenz\\atsiriBookingApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-090d8fb0"]])

export default __exports__